import React from 'react';

const ProdToPrint = React.forwardRef(({ prod, params }, ref) => {
  const {
    sku,
    img,
    unit,
    altUnit,
    hasAltItem,
    showPrice,
    showPromoPrice,
    price,
    promoPrice,
    altPrice,
    altPromoPrice,
    isAvailable,
    name,
    brand,
    brandImg,
    multiplier,
    showPkgMsg,
    pkgMsg,
    props,
  } = prod;

  const renderPrice = showPrice;
  const currPrice = showPromoPrice ? promoPrice : price;
  const currAltPrice = showPromoPrice ? altPromoPrice : altPrice;
  const renderPkgMsg = showPrice && showPkgMsg && pkgMsg !== '';

  const schedule = document.getElementById('footer-schedule').innerHTML;
  const holidays = window.holidays;

  let fstProps = [];
  let scndProps = [];
  const splitPropsBy = 9;

  if (props.length > 0) {
    fstProps = props.slice(0, splitPropsBy);
    scndProps = props.slice(splitPropsBy);
  }

  return (
    <div ref={ref}>
      <div className="container" style={{ paddingBottom: 50 }}>
        <div className="print_header">
          <div className="site_logo">
            <img src="/img/logo2.png" alt="" />
          </div>
          <div className="print_contacts">
            <div className="contacts_title">
              <div>ООО "ТД Клавка Групп"</div>
              <div>+7 (812) 600-42-42</div>
              <div>info@klavka.ru</div>
            </div>
          </div>
          <div className="showroom">
            Шоурум: Санкт-Петербург, Ключевая улица, д. 30, оф. 110
          </div>
          <div
            className="print_time"
            dangerouslySetInnerHTML={{ __html: schedule }}
          />
          <div className="qr_print">
            <img src="/img/qr_print.jpg" alt="" />
          </div>
        </div>

        <div className="h1">{name}</div>

        <div className="prod">
          <div className="clinker__block">
            <div>
              <div className="swiper">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <img src={img} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="clinker__cnt">
            <div className="brand">
              <div className="print-sku">Артикул: {sku}</div>

              <div className="log-prem">
                <img src={brandImg} alt={brand} />
              </div>
            </div>

            {renderPrice && (
              <div className="price">
                <strong>* {currPrice}</strong>
                <span>&nbsp;&#x20BD;/{unit}</span>
                {hasAltItem && altUnit !== undefined && (
                  <i>
                    &nbsp;({currAltPrice} &nbsp;&#x20BD;/{altUnit})
                  </i>
                )}
                <div className="quantity-goods">
                  {renderPkgMsg && (
                    <>
                      {pkgMsg} ({multiplier} {unit})
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="delivery__box">
              <div className="delivery__address">
                <span>Доставка</span>
                <p>Санкт-Петербург и Ленинградская обл.</p>
              </div>
              {showPrice && isAvailable && (
                <>
                  <div className="delivery__info">
                    <span className="delivery-about">
                      Сроки доставки уточняйте у менеджеров
                    </span>
                  </div>
                  <div className="delivery__info">
                    <p>Самовывоз</p>
                    <span>— бесплатно, завтра</span>
                  </div>
                  <div className="delivery__info">
                    <p>{holidays.join(', ')}</p>
                    <span>— выходной</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <h4>О товаре</h4>

        <div className="props">
          <div>
            <div>Производитель - {brand}</div>
            {fstProps.map((p, idx) => {
              const { name, value } = p;
              return (
                <div key={`prop-key-${idx}`}>
                  {name} - {value}
                </div>
              );
            })}
          </div>
          <div>
            {scndProps.map((p, idx) => {
              const { name, value } = p;
              return (
                <div key={`prop-key-${idx}`}>
                  {name} - {value}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="print_footer">
        <div className="print_footer_inner">
          <div className="call-manager">
            * Актуальную стоимость уточняйте у менеджеров:
            <br /> +7 (812) 600-42-42
          </div>

          <div className="print-date">
            Дата печати: <br /> {new Date().toLocaleDateString('ru-RU')},&nbsp;
            {new Date().toLocaleTimeString('ru-RU')}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProdToPrint;
